unit NetListType;

interface

uses
  NetType;

type
  TNetListType = array of TNetType;

implementation

end.
